import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { CouponProps } from '../api/response';

export const useSearchCouponQuery = (search: string) => {
  const axios = useAxios();

  return useQuery(
    ['search-coupon', search],
    () => axios.get<AxiosResponse<CouponProps[]>>(`${ApiRoutes.searchCoupon}?search=${search}`),
    {
      select: res => res.data.data,
      keepPreviousData: true,
      retry: false,
      enabled: false,
      cacheTime: USE_QUERY_CONSTANTS.cacheMs,
    },
  );
};
